module.exports = __webpack_public_path__ + "assets/img/YouTube-white.7acc4f62.svg";